module.exports = __webpack_public_path__ + "img/pride-logo.a0e8bd52.jpg";